var _style, _g, _line, _line2, _line3, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeCardsManagePrayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#212E5F;}\r\n\t.st1{display:none;fill:none;stroke:#212E5F;stroke-width:44;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st2{display:none;fill:none;stroke:#212E5F;stroke-width:32;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189,382.5c13.9-20.9-10.3-36.3-28.7-39.3c1.3-1.8,6.6-5.7,2.2-6.8c-4.7-0.8-10.4,0.8-12.6,5.3 c-17.5-5-107.4,12.1-71.6,39.8c5.1,2.7,10.9,6.3,16.5,5.9c2.4-0.2,1.6-2.3-0.2-2.7c-19.8-6.6-17.3-22.4,0.5-29.9 c16.2-7.4,34.6-10.7,52.3-10c-1.7,2.3-5.1,5.2-5.1,8.2c-7.3,9.1-14,18.9-20.4,28.4c-12,3.6-43.6,22.3-21.2,33.6 c-4.6,9-23.8,41.3-0.5,37.4c1.8-0.4,11.2-2.2,7.4-4.1c-2.3-0.6-6.2,2.4-7.6-0.4c-1.7-9.9,5-22,8.8-30.9 C137.6,420.3,171.8,406.5,189,382.5z M139.9,378.9c2.1-0.7,4.4-0.6,6.3-1.8c4.6-5.2-11.7,0.6-13.4,0.8c7.8-11,16.2-21.8,25.2-32.2 c72.1,13.7-12.3,75.7-47.5,68c5.9-11.2,12.4-21.6,19.6-31.9C133.4,380.8,136.5,379.7,139.9,378.9z M118.3,386.6 c-5.4,7.9-10.3,15.7-15.2,24.1C92.6,401.1,110.8,390.9,118.3,386.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M220.9,401.6c8.2-27.9-24.2,3-29.4,10.3c2.2-7.5,7-14.4,9.1-21.8c0-3.9-7.3-0.7-8.6,1.1 c-0.4,1.4-8.5,11.2-4.2,10.6c-4.6,11.4-8.5,23.1-14.8,33.7c0.4,3.4,6.8-0.6,8.8-1.5c4.4-2.4,3.2-7.2,5.7-11 c5.4-9,15.4-21.1,25.5-24.9c1.9,0.8,1.6,3.2,1.3,4.8C214.9,405.7,219.9,404.2,220.9,401.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.2,395.6c6.3-10.4-8.2-6.8-9.5-0.4c-4.1,11.4-14.5,23-23.6,31.1c-6.3,5-6.9,1-4.7-4.9 c0.1-5.8,18.8-28.3,12.7-28.2c-9-0.5-11,5.2-14.6,12c-0.7,1.1-0.4,2,0.6,2.4c-2.4,4.9-5.8,10-6.9,15.5 c-19.8,21.5-13.2-11.3-8.2-21.8c3.1-3.4,8.4-15.3-1.3-10.9c-4.8-1.3-9.8-0.9-14,1.8c-15.3,1.6-25.6,25.8-27.3,39.3 c2.6,15.6,27.4-13.2,30.8-18.6c-5.2,18.9,2.5,33,19.8,15.2c2.4,23.1,27.6-11.1,32.7-17.7c-1.9,10.3-6.4,19.5-10.1,29.3 c-122.1,10.9-37,99,6,2.9c7.9,1.3,11.8-3.4,1.2-3C303.4,425.4,306.2,409.4,313.2,395.6z M252.4,394.7c-7,13.4-12.6,26-26,34.2 c-0.8,0.4-1.8,1.2-1.9,0C227.9,417.9,237.8,391.7,252.4,394.7z M287.9,442.3c-8.7,16.3-22.1,38.9-43,39.6c-5.7-0.1-12.3-2.9-12-9.7 C237.2,450.3,269,444,287.9,442.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M347.4,416.7c-1.7,0.6-5.3,5.3-7.9,7.4c-16.3,14.2-25.6,6-14.2-12.2c7.5-1.7,15-2.6,22.6-1.7 c6.4-0.5,0.1-3.5-2.5-3.8c7.1-5.3,13.2-22.9-2.2-17.6c-0.4,0.1-1.7,0.6-1.7,1.6c-0.4,1.3,3.3,1.3,3.4,1.5c1,4.1-1.9,10.5-4.1,13.9 c-4.2-0.4-8.4,0.1-12.6,0.7c2.7-4.9,7.9-10.6,11.4-14.3c-0.6-1.9-3.4-0.7-5-0.5c-9.1,2.4-13.8,11.9-18.7,19 c-7.6,18-11.3,30.8,14.4,21.9C334.2,431.9,352.4,420.3,347.4,416.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M395.8,401.6c8.2-27.9-24.2,3-29.4,10.3c2.2-7.5,7-14.4,9.1-21.8c0-3.9-7.3-0.7-8.6,1.1 c-0.4,1.4-8.5,11.2-4.2,10.6c-4.6,11.4-8.5,23.1-14.8,33.7c0.4,3.4,6.8-0.6,8.8-1.5c4.4-2.4,3.2-7.2,5.7-11 c5.4-9,15.4-21.1,25.5-24.9c1.9,0.8,1.6,3.2,1.3,4.8C389.8,405.7,394.8,404.2,395.8,401.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M426.8,388.5c-11.2,0.8-33.3,11.7-24.3,25.4c3.4,4.9,13,6.9,12.7,13.5c-6.2,0.6-16.5,2-22,5.3 c-5.5,3.2-3.1,5.7,2.2,5.5c7.5-0.1,16.6-1.8,22.2-7.2c2.5-0.6,5-0.6,7.3-1.6c3.3-3-3.1-2.4-4.9-2.2c8-11.7-12.2-13.3-11.9-23.7 c-0.7-9.9,21.4-14.8,15.4-1.1C426.5,407,439.7,389.8,426.8,388.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234,358.1l-4.6-28.2h-9.8l-6.5,39h7.6c1.3-6.4,3.3-22.8,4.1-29.5l5.1,29.5h5.2l14.4-28.5 c-1.5,6.7-4.6,21.8-5.5,28.5h7.6l6.5-39H248L234,358.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.8,360.8H281l1.2,8h7.7l-7.2-38.9h-7l-20.1,38.9h8.4L267.8,360.8z M277.9,339.8l2.1,14.5h-9L277.9,339.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "318.1,355.9 307.6,329.9 300.2,329.9 293.7,368.9 301.3,368.9 305.7,342.9 316.1,368.9 323.5,368.9  330,329.9 322.5,329.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M339.7,360.8h13.1l1.2,8h7.7l-7.2-38.9h-7l-20.1,38.9h8.4L339.7,360.8z M349.8,339.8l2.1,14.5h-9.1 L349.8,339.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378,340.2c3.4-6.3,13.4-5.8,13.4,2.2h7.3c-0.4-15.5-20-17-27-5.1c-6.7,10.4-7.4,32,8.9,32.4 c5.5,0.1,11.5-1.4,14.7-5.5l2.3-15.5h-14.4l-1,5.9h6.9l-1.3,6.7c-2.9,2.2-9.4,3.2-11.5-0.7C373.2,355.5,375.6,343.8,378,340.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "430.3,336.4 431.4,329.9 406.9,329.9 400.3,368.9 424.9,368.9 426,362.4 409,362.4 410.7,351.9  425.2,351.9 426.3,345.7 411.8,345.7 413.4,336.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.4,97V66.8L87,72.7l-6.6-3.8l12.3-21.4l11.1,19.3V35.6c-1.4-0.2-2.9-0.3-4.4-0.3C82.1,35.3,68,49.4,68,66.8 C68,81,77.5,93.1,90.4,97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.1,66.8L95.1,66.8v31.1c1.4,0.2,2.9,0.3,4.4,0.3c17.4,0,31.5-14.1,31.5-31.5c0-14.2-9.5-26.3-22.4-30.2 v30.2l3.4-5.9l6.6,3.8L106.2,86L95.1,66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.4,188v-30.1l-3.4,5.9l-6.6-3.8l12.3-21.4l11.1,19.3v-31.3c-1.4-0.2-2.9-0.3-4.4-0.3 c-17.4,0-31.5,14.1-31.5,31.5C68,172,77.5,184.1,90.4,188z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.6,127.6v30.2l3.4-5.9l6.6,3.8l-12.4,21.4l-11.1-19.3l0,0V189c1.4,0.2,2.9,0.3,4.4,0.3 c17.4,0,31.5-14.1,31.5-31.5C131,143.5,121.5,131.5,108.6,127.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.4,280v-30.1l-3.4,5.9l-6.6-3.8l12.3-21.4l11.1,19.3v-31.3c-1.4-0.2-2.9-0.3-4.4-0.3 c-17.4,0-31.5,14.1-31.5,31.5C68,264,77.5,276.1,90.4,280z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.1,249.8L95.1,249.8v31.1c1.4,0.2,2.9,0.3,4.4,0.3c17.4,0,31.5-14.1,31.5-31.5c0-14.2-9.5-26.3-22.4-30.2 v30.2l3.4-5.9l6.6,3.8L106.2,269L95.1,249.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170,86c27.7,0,55.4,0,83.2,0c44.2,0,88.3,0,132.5,0c10.1,0,20.2,0,30.4,0c9.4,0,18.4-8.3,18-18 c-0.4-9.8-7.9-18-18-18c-27.7,0-55.4,0-83.2,0c-44.2,0-88.3,0-132.5,0c-10.1,0-20.2,0-30.4,0c-9.4,0-18.4,8.3-18,18 C152.4,77.8,159.9,86,170,86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416,140c-27.7,0-55.4,0-83.2,0c-44.2,0-88.3,0-132.5,0c-10.1,0-20.2,0-30.4,0c-9.4,0-18.4,8.3-18,18 c0.4,9.8,7.9,18,18,18c27.7,0,55.4,0,83.2,0c44.2,0,88.3,0,132.5,0c10.1,0,20.2,0,30.4,0c9.4,0,18.4-8.3,18-18 C433.6,148.2,426.1,140,416,140z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416,232c-27.7,0-55.4,0-83.2,0c-44.2,0-88.3,0-132.5,0c-10.1,0-20.2,0-30.4,0c-9.4,0-18.4,8.3-18,18 c0.4,9.8,7.9,18,18,18c27.7,0,55.4,0,83.2,0c44.2,0,88.3,0,132.5,0c10.1,0,20.2,0,30.4,0c9.4,0,18.4-8.3,18-18 C433.6,240.2,426.1,232,416,232z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 173.8,
    y1: 74.6,
    x2: 404,
    y2: 74.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 173.8,
    y1: 164.2,
    x2: 404,
    y2: 164.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 173.8,
    y1: 253.7,
    x2: 404,
    y2: 253.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 109.8,
    cy: 74.6,
    r: 12.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 109.8,
    cy: 164.2,
    r: 12.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 109.8,
    cy: 253.7,
    r: 12.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCardsManagePrayers);
export default __webpack_public_path__ + "static/media/homeCards-managePrayers.c8e59c9a7c653b3bb0999505a8e0c38b.svg";
export { ForwardRef as ReactComponent };